import { render } from "./works.vue?vue&type=template&id=4490368a"
import script from "./works.vue?vue&type=script&lang=js"
export * from "./works.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__